import PropTypes from 'prop-types'
import React from 'react'
import classes from './Menu.module.scss'
import Scrollbars from 'components/Scrollbars'

export class Menu extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    hover: PropTypes.bool
  }

  render () {
    const {
      children,
      className,
      hover,
      ...restProps
    } = this.props

    let compClassName = 'dropdown-menu ' + classes.menu
    if (className) compClassName += ' ' + className
    if (hover) compClassName += ' ' + classes.hover
  
    return (
      <Scrollbars
        {...restProps}
        component='ul'
        className={compClassName}
      >
        {children}
      </Scrollbars>
    )
  }
}

export default Menu

